import React, { FC } from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { MaterialIcon } from '../../../components';
import { useTranslation } from '../../../translations';

export const UnverifiedEmailIcon: FC<{ readonly userId: number }> = ({ userId }) => {
  const { ts } = useTranslation();
  const id = `emailNotVerified${userId}`;
  return (
    <>
      <span className="inline-icon" id={id}>
        <MaterialIcon name="report" type="danger" />
      </span>
      <UncontrolledPopover placement="bottom" target={id} trigger="hover">
        <PopoverBody>
          <p>{ts('this_user_has_not_yet_confirmed_their_e_mail_address')}</p>
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};
